import { merge } from '../../../../utils/state';
import entity from '../../entities/hubs/entity';
import { TYPES } from './actions';

const coreReducer = entity.getReducer();

const initialState = {
  featureElementCount: {
    data: {},
    error: null,
    isLoading: false,
  },
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.HUB_FEATURE_ELEMENT_COUNT_REQUEST:
      return merge(state, {
        featureElementCount: merge(state.featureElementCount, {
          error: null,
          isLoading: true,
        }),
      });
    case TYPES.HUB_FEATURE_ELEMENT_COUNT_SUCCESS:
      return merge(state, {
        featureElementCount: merge(state.featureElementCount, {
          data: action.payload,
          isLoading: false,
        }),
      });
    case TYPES.HUB_FEATURE_ELEMENT_COUNT_FAILURE:
      return merge(state, {
        featureElementCount: merge(state.featureElementCount, {
          error: action.payload,
          isLoading: false,
        }),
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
